import type { SubscriptionTierCode } from './types';

export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription';
}

export const stripeProducts: Record<SubscriptionTierCode, StripeProduct> = {
  business: {
    id: 'prod_SCWHGdvjJBN557',
    priceId: 'price_1RI7EbCR1PmgtlamWFsE2FpQ',
    name: 'ENTEK.AI Business',
    description: 'Business tier',
    mode: 'subscription'
  },
  enterprise: {
    id: 'prod_SCWHR5MdJaGgNk',
    priceId: 'price_1RI7FHCR1Pmgtlamy3gxToMX',
    name: 'ENTEK.AI Enterprise',
    description: 'Enterprise tier',
    mode: 'subscription'
  },
  ultimate: {
    id: 'prod_SCWIJF4ucxwGxn',
    priceId: 'price_1RI7FpCR1PmgtlamkNt5MyYW',
    name: 'ENTEK.AI Ultimate',
    description: 'Ultimate tier',
    mode: 'subscription'
  },
  free: {
    id: 'free',
    priceId: 'free',
    name: 'Free',
    description: 'Free tier',
    mode: 'subscription'
  }
};